import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154 174.5C154 176.986 129.825 179 100 179C70.1718 179 46 176.986 46 174.5C46 172.017 70.1718 170 100 170C129.825 170 154 172.017 154 174.5Z"
      fill="#CBD6E4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.785 143.784H40.1941C35.6699 143.784 32.0022 140.116 32.0022 135.592V47.5291C32.0022 43.0018 35.6699 39.3372 40.1941 39.3372H150.785C155.309 39.3372 158.977 43.0018 158.977 47.5291V135.592C158.977 140.116 155.309 143.784 150.785 143.784Z"
      fill="#F8FBFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.294 39H40.195C37.3651 39 34.8734 40.4336 33.3994 42.6119C32.5182 43.9182 32 45.4945 32 47.1919V135.255C32 136.704 32.4096 138.044 33.0705 139.223L133.294 39Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.785 143.784H40.1941C35.6699 143.784 32.0022 140.116 32.0022 135.592V47.5291C32.0022 43.0018 35.6699 39.3372 40.1941 39.3372H150.785C155.309 39.3372 158.977 43.0018 158.977 47.5291V135.592C158.977 140.116 155.309 143.784 150.785 143.784Z"
      stroke="#9BABC2"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.785 39.3369H40.1941C35.6699 39.3369 32.0022 43.0046 32.0022 47.5288V63.9126H158.977V47.5288C158.977 43.0046 155.309 39.3369 150.785 39.3369Z"
      fill="#F8FBFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.785 39.3369H40.1941C35.6699 39.3369 32.0022 43.0046 32.0022 47.5288V63.9126H158.977V47.5288C158.977 43.0046 155.309 39.3369 150.785 39.3369Z"
      stroke="#9BABC2"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect x="61" y="80" width="54" height="3" rx="1.5" fill="#9BABC2" />
    <circle
      cx="49.5"
      cy="81.5"
      r="5.5"
      fill="#BECFE6"
      stroke="#9BABC2"
      strokeWidth="2"
    />
    <path
      d="M54 80.7543C54 81.4131 51.7782 80.5383 49.4931 80.5383C47.208 80.5383 45 81.4131 45 80.7543C45 78.9383 47.2383 77 49.5234 77C51.8085 77 54 78.9383 54 80.7543Z"
      fill="#E8F4FA"
    />
    <rect x="61" y="102" width="33" height="3" rx="1.5" fill="#9BABC2" />
    <circle
      cx="49.5"
      cy="103.5"
      r="5.5"
      fill="#BECFE6"
      stroke="#9BABC2"
      strokeWidth="2"
    />
    <path
      d="M54 102.754C54 103.413 51.7782 102.538 49.4931 102.538C47.208 102.538 45 103.413 45 102.754C45 100.938 47.2383 99 49.5234 99C51.8085 99 54 100.938 54 102.754Z"
      fill="#E8F4FA"
    />
    <rect x="61" y="124" width="18" height="3" rx="1.5" fill="#9BABC2" />
    <circle
      cx="49.5"
      cy="125.5"
      r="5.5"
      fill="#BECFE6"
      stroke="#9BABC2"
      strokeWidth="2"
    />
    <path
      d="M54 124.754C54 125.413 51.7782 124.538 49.4931 124.538C47.208 124.538 45 125.413 45 124.754C45 122.938 47.2383 121 49.5234 121C51.8085 121 54 122.938 54 124.754Z"
      fill="#E8F4FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.308 51.6248C147.308 53.143 146.078 54.3738 144.559 54.3738C143.041 54.3738 141.81 53.143 141.81 51.6248C141.81 50.1065 143.041 48.8757 144.559 48.8757C146.078 48.8757 147.308 50.1065 147.308 51.6248Z"
      fill="#BECFE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.308 51.6248C147.308 53.143 146.078 54.3738 144.559 54.3738C143.041 54.3738 141.81 53.143 141.81 51.6248C141.81 50.1065 143.041 48.8757 144.559 48.8757C146.078 48.8757 147.308 50.1065 147.308 51.6248Z"
      stroke="#9BABC2"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.167 125.244C167.167 144.984 151.23 160.989 131.572 160.989C111.913 160.989 95.9766 144.984 95.9766 125.244C95.9766 105.505 111.913 89.5026 131.572 89.5026C151.23 89.5026 167.167 105.505 167.167 125.244Z"
      fill="#E6EDF7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.167 125.244C167.167 144.984 151.23 160.989 131.572 160.989C111.913 160.989 95.9766 144.984 95.9766 125.244C95.9766 105.505 111.913 89.5026 131.572 89.5026C151.23 89.5026 167.167 105.505 167.167 125.244Z"
      stroke="#9BABC2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.429 125.244C159.429 140.693 146.958 153.215 131.57 153.215C116.185 153.215 103.714 140.693 103.714 125.244C103.714 109.796 116.185 97.2734 131.57 97.2734C146.958 97.2734 159.429 109.796 159.429 125.244Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.571 105.042C145.641 105.042 157.241 115.523 159.13 129.129C159.307 127.855 159.43 126.566 159.43 125.245C159.43 109.796 146.956 97.2717 131.571 97.2717C116.186 97.2717 103.715 109.796 103.715 125.245C103.715 126.566 103.835 127.855 104.015 129.129C105.901 115.523 117.503 105.042 131.571 105.042Z"
      fill="#F0F0F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.429 125.244C159.429 140.693 146.958 153.215 131.57 153.215C116.185 153.215 103.714 140.693 103.714 125.244C103.714 109.796 116.185 97.2734 131.57 97.2734C146.958 97.2734 159.429 109.796 159.429 125.244Z"
      stroke="#9BABC2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M128.226 109.37C128.226 107.44 129.79 105.876 131.721 105.876C133.651 105.876 135.215 107.44 135.215 109.37V131.381C135.215 133.311 133.651 134.876 131.721 134.876C129.79 134.876 128.226 133.311 128.226 131.381V109.37Z"
      fill="#BECFE6"
      stroke="#9BABC2"
      strokeWidth="2"
    />
    <path
      d="M129.224 109.372C129.224 107.993 130.342 106.876 131.721 106.876C133.099 106.876 134.217 107.993 134.217 109.372V112.876L129.224 115.876V109.372Z"
      fill="#E8F4FA"
    />
    <ellipse
      cx="131.721"
      cy="141.376"
      rx="3.49468"
      ry="3.5"
      fill="#BECFE6"
      stroke="#9BABC2"
      strokeWidth="2"
    />
    <path
      d="M134.217 140.958C134.217 141.376 133.099 140.851 131.721 140.851C130.342 140.851 129.224 141.376 129.224 140.958C129.224 139.808 130.342 138.876 131.721 138.876C133.099 138.876 134.217 139.808 134.217 140.958Z"
      fill="#E8F4FA"
    />
  </svg>
);
